import { IconStopwatch } from '@tabler/icons-react';
import type { BlockDefinition } from '@/components/canvas/blocks/registry/types';
import { registerBlockDefinition } from '@/components/canvas/blocks/registry/blockRegistry';
import type { TimerBlock } from '@/components/canvas/blocks/types';
import { createTimerBlock } from '@/components/canvas/blocks/timer/createTimerBlock';
import { estimateTimerContentSize } from '@/components/canvas/blocks/timer/contentMetrics';
import { TimerBlockView } from '@/components/canvas/blocks/timer/TimerBlockView';
import { TimerProperties } from '@/components/canvas/blocks/timer/TimerProperties';

const DEFAULT_SIZE = 220;

export const timerBlockDefinition: BlockDefinition<TimerBlock> = {
  type: 'timer',
  label: '定时器',
  defaultSize: { width: DEFAULT_SIZE, height: DEFAULT_SIZE },
  minSize: { width: 80, height: 80 },
  contentInteractive: true,
  create: (ctx) =>
    createTimerBlock({
      id: ctx.id,
      x: ctx.x,
      y: ctx.y,
      width: ctx.width,
      height: ctx.height,
      zIndex: ctx.zIndex,
      name: ctx.name,
    }),
  estimateContentSize: (data) => estimateTimerContentSize(data),
  View: TimerBlockView,
  Properties: TimerProperties,
  menuItem: {
    type: 'timer',
    label: '定时器',
    Icon: IconStopwatch,
  },
};

registerBlockDefinition(timerBlockDefinition);
